import React from "react";
import styled from "styled-components";
import GText from "./gText";

const Ul = styled.ul`
  display: flex;
  width: 100%;
  margin: 0 0 20px 0;
  padding: 0;
  list-style-type: none;
`;
const Li = styled.li`
  padding: 15px 10px;
  text-align: left;
  font-size: 13.5px;
  position: relative;
  display: block;
  float: left;
  cursor: pointer;
  p {
    margin: 5px 0;
  }
`;

export default function orderStatuses(props) {
  function handleClick(iden) {
    console.info("You clicked a breadcrumb.");
    props.onClickStatus(iden);
  }

  return (
    <div>
      <Ul>
        {props.statusList.map((status) => {
          return (
            <Li
              onClick={() => {
                handleClick(status.identifier);
              }}
              key={status.identifier}
              style={{
                color: "#" + status.color1,
                background: "#" + status.color2,
                borderBottom:
                  props.defaultStatus === status.identifier
                    ? "4px solid #" + status.color1
                    : "",
                width: "18%",
              }}
              className={(props.class, status.color)}
            >
              <GText
                g5
                text={status.count + " " + status.title + " Bookings"}
                style={{ color: "#" + status.color1 }}
              />
            </Li>
          );
        })}
      </Ul>
    </div>
  );
}
